import { simpleSet } from '@r/reducers/utils';

const setCalculationModeSameAsCustomerAddress = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.information.sameAsCustomerAddress;

export const sameAsCustomerAddress = setCalculationModeSameAsCustomerAddress(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_SAME_AS_CUSTOMER_ADDRESS',
  false
);
